// extracted by mini-css-extract-plugin
export default {"zoom":"ZoomHandler_zoom__qLdxC font-sm-medium","zoom__btn":"ZoomHandler_zoom__btn__OYjtD"};